import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * רשת ביטחון לכל האפליקציה: שגיאת רינדור בלתי צפויה (או קובץ קוד שנעלם אחרי עדכון גרסה) מציגה
 * מסך טרמינל מעוצב עם כפתור "טען מחדש", במקום מסך שחור/לבן בלי שום הסבר.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('UI crashed', error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="app-page">
        <div className="empty-state term-text" role="alert">
          <p>&gt; אירעה שגיאה בלתי צפויה במסוף.</p>
          <p>&gt; המשימות והפתקים שלך שמורים — אפשר לטעון מחדש בבטחה.</p>
          <button type="button" className="btn btn--primary" onClick={() => window.location.reload()}>
            טען מחדש
          </button>
        </div>
      </div>
    );
  }
}
